// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Zude","label":"CategoryService_label__2jwso","location":"CategoryService_location__3gqZI"};